import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Icon } from '@drdropin-tech/theseus';
import { useRouter } from 'next/router';
import { useEffect, useRef, useState } from 'react';
import { Link } from '../index';
export default function LocaleSwitcher({ locales, translation, }) {
    const router = useRouter();
    const [isOpen, setIsOpen] = useState(false);
    const ref = useRef(null);
    // Close the dropdown when clicking outside of it
    useEffect(() => {
        document.addEventListener('click', (e) => {
            if (ref.current &&
                !ref.current.contains(e.target)) {
                setIsOpen(false);
            }
        });
        return () => {
            document.removeEventListener('click', () => { });
        };
    }, []);
    return (_jsxs("div", { ref: ref, children: [_jsx(Icon, { role: "button", tabIndex: 1, "aria-label": translation('navigation.switch_language'), name: "Globe", onClick: () => setIsOpen(!isOpen), className: "cursor-pointer" }), isOpen && (_jsxs(_Fragment, { children: [_jsx(Icon, { name: "Play", fill: "white", className: "absolute top-8 z-10 rotate-[-90deg]" }), _jsx("div", { className: "absolute right-0 top-12 flex flex-col items-center justify-center rounded-lg bg-white p-2 shadow-sm shadow-inherit", children: _jsx("ul", { children: locales?.map((locale) => (_jsx("li", { children: _jsx(Link, { locale: locale.locale, to: router.asPath, className: "text-black no-underline", children: _jsxs("div", { className: "flex flex-row justify-between gap-3 p-2", children: [router.locale === 'nb'
                                                ? locale.labels.nb
                                                : locale.labels.en, locale.locale === router.locale && (_jsx(Icon, { name: "Check", className: "relative top-1 ml-2" }))] }) }) }, locale.locale))) }) })] }))] }));
}
